import React from "react";
import { CV } from "../components/cv";
import JohannesTImg from "@/assets/images/johannes-t.png";

export default function CVJohannesTegner() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Johannes Tegnér";
  }, []);

  return (
    <CV
      name="Johannes Tegnér"
      title="Developer"
      subtitle="Backend, containerization and operations specialist — projects with Tetra Pak and inRiver"
      photo={JohannesTImg}
      summary="Developer with experience and education within game, web and application programming. Strongly focused on backend, containerization and operations. Founder and Owner of Jitesoft."
      skills={{
        "Languages": ["C#", "C++", "Java", "JavaScript", "TypeScript", "PHP"],
        "Databases": ["MySQL", "MsSQL", "MongoDB", "Redis", "ElasticSearch", "Postgres"],
        "Infrastructure": ["Docker", "Kubernetes", "Ansible", "Terraform/HCL"],
      }}
      experience={[
        {
          role: "Founder / Owner and developer",
          company: "Jitesoft AB",
          period: "2016 - Present",
          description:
            "Jitesoft is my personal company which I in 2022 turned into an aktiebolag from a sole proprietorship. The primary source of income for Jitesoft AB is consulting. When not on contract, most of the work is done as open source. The company is focused on backend development and operations.",
          highlights: [
            "Customer projects using C#, PHP or Node.js as backend with React, Vue and custom frameworks",
            "Internal projects using C# and PHP for back-end, JavaScript and C# (WebAssembly) for front-end",
            "Focus on automation and containerization using ansible, terraform, docker, kubernetes and CI/CD tools like gitlab-ci",
            "Projects: TetraPak, InRiver, Fitness24seven, Teknikveckan",
          ],
        },
        {
          role: "Co-Founder, CTO & Chairman of the board",
          company: "KRIGio AB",
          period: "2019",
          description:
            "Responsibilities as CTO including technical leadership and architecture decisions.",
        },
        {
          role: "Partner / Administrator",
          company: "KRIG Collective",
          period: "2017 - 2019",
          description:
            "Joined the freelance collective KRIG and quickly started working with core members on internal and external projects, working as 'CTO' in the collective. KRIG was later re-formed as an AB (KRIGio).",
          highlights: [
            "Development with JavaScript on both front and back-end, PHP on backend",
            "Worked with frameworks such as WordPress, Laravel, React, Vue, and custom solutions",
            "Managed infrastructure and internal kubernetes cluster",
            "Containerized all projects and handled issues and support through email and Jira",
            "Projects: RedBull, Djurens rätt, Studieförbunden",
          ],
        },
        {
          role: "CTO",
          company: "Cardz LLC",
          period: "2017",
          description:
            "Started company to create an application for iOS and Android using OCR to scan trading cards, making them searchable and tradeable over a marketplace.",
          highlights: [
            "Main application written in C# using Xamarin",
            "PHP API backend with MySQL database",
            "OCR workers written in NodeJS using Tesseract-OCR",
            "MongoDB and ElasticSearch for fuzzy search capabilities",
            "Docker containers in stateless environment with AWS databases",
          ],
        },
        {
          role: "Programmer",
          company: "Auranest",
          period: "2015 - 2016",
          description:
            "Worked with the Auranest platform. Main area was the back-end and push system, mostly written in PHP and JavaScript (Node.js). Used agile scrum-like development method with Jira and Git.",
        },
        {
          role: "System Developer",
          company: "Talkative Labs (Aesculus AB)",
          period: "2012 - 2014",
          description:
            "Initially hired for C# and Unity3D experience for R&D project. Most back-end code using Node.js and MongoDB, with some PHP systems. Built for cross-platform compatibility using JavaScript, C++ with Qt, Java (Android) or C# .net/mono.",
        },
        {
          role: "Programmer",
          company: "Junebud AB",
          period: "2012 - 2014",
          description:
            "Worked on MilMo, a free to play game developed using Unity3d engine with Java server, and helped with TuffTanks, a free to play tank game for iPad.",
        },
      ]}
      education={[
        {
          degree: "Programming, Games",
          institution: "The Game Assembly",
          year: "2008-2011",
        },
        {
          degree: "Programming, C# .Net",
          institution: "Malmö Högskola",
          year: "2011",
        },
        {
          degree: "Programming, Java",
          institution: "Malmö Högskola",
          year: "2011",
        },
        {
          degree: "Programming, C# .Net",
          institution: "Ekbackeskolan",
          year: "2006-2007",
        },
        {
          degree: "Web-design",
          institution: "Fridhems Folkhögskola",
          year: "2005-2006",
        },
      ]}
    />
  );
}
